
/*****************************************
    main.js 项目的核心文件
            引用组件时需要修改
*****************************************/

import Vue from 'vue'
import App from './App.vue'                     // 导入项目入口文件
import router from './router'                   // 导入Vue路由
import store from './store'                     // 导入仓库
import ElementUI from 'element-ui';             // 导入Ele UI组件库
import 'element-ui/lib/theme-chalk/index.css';  // 导入Ele CSS资源库

import {postRequest} from "./utils/api";        // 导入Req_api 函数post
import {postKeyValueRequest} from "./utils/api";// 导入Req_api 函数postKeyValue
import {putRequest} from "./utils/api";         // 导入Req_api 函数put
import {deleteRequest} from "./utils/api";      // 导入Req_api 函数delete
import {getRequest} from "./utils/api";         // 导入Req_api 函数get

import {initMenu} from "./utils/menus";         // 导入菜单 函数initMenus...

import {downFile} from "./utils/util"

import 'font-awesome/css/font-awesome.min.css'  // 导入Awesome网页字体图标库


import './styles/base/font-yx-soft.css'  // 导入yx字体库
import '../static/css/app.css'           // 导入app.css
import BaiduMap from 'vue-baidu-map'     // 全局注册(一次性引入百度地图组件的所有组件)

import echarts from 'echarts'
Vue.prototype.g_echarts = echarts; //  $g_echarts 就在所有Vue实例中可用了。this.$echarts。$符号无特殊含义，只为规范为全局作用域

Vue.prototype.postRequest = postRequest;
Vue.prototype.postKeyValueRequest = postKeyValueRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.initMenu = initMenu;

import moment from "moment"
Vue.prototype._moment = moment;

import {StringUtils} from "./utils/stringUtils"

import {enums} from "./utils/enums"

Vue.prototype._enums = enums;

Vue.prototype._StringUtils = StringUtils;


Vue.prototype._p_env = process.env;
Vue.prototype._downFile = downFile;
/*
import _GLB from './config/Global'
Vue.prototype._GLB = _GLB
*/
Vue.config.productionTip = false

Vue.use(ElementUI,{size:'small'});      // 按需引入Ele UI库，减小项目体积

Vue.use(BaiduMap, {
    ak: 'SoB3vEjhhpzwskYsfNv3Ic2a85SWGLZG'
})

Vue.config.devtools = true


import './global.less' // global style
import 'ant-design-vue/dist/antd.less'

import {
    ConfigProvider,
    Layout,
    Input,
    InputNumber,
    Button,
    Switch,
    Radio,
    Checkbox,
    Select,
    Card,
    Form,
    FormModel,
    Row,
    Col,
    Modal,
    Table,
    Tabs,
    Icon,
    Badge,
    Popover,
    Dropdown,
    List,
    Avatar,
    Breadcrumb,
    Steps,
    Spin,
    Menu,
    Drawer,
    Tooltip,
    Alert,
    Tag,
    Divider,
    DatePicker,
    TimePicker,
    Upload,
    Progress,
    Skeleton,
    Popconfirm,
    PageHeader,
    Result,
    Statistic,
    Descriptions,
    Space,
    Pagination,
    message,
    notification,
    Tree
} from 'ant-design-vue'

Vue.use(ConfigProvider)
Vue.use(Layout)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Card)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Row)
Vue.use(Col)
Vue.use(Modal)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Badge)
Vue.use(Popover)
Vue.use(Dropdown)
Vue.use(List)
Vue.use(Avatar)
Vue.use(Breadcrumb)
Vue.use(Steps)
Vue.use(Spin)
Vue.use(Menu)
Vue.use(Drawer)
Vue.use(Tooltip)
Vue.use(Alert)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Skeleton)
Vue.use(Popconfirm)
Vue.use(PageHeader)
Vue.use(Result)
Vue.use(Statistic)
Vue.use(Descriptions)
Vue.use(Space)
Vue.use(Pagination)
Vue.use(Tree)

/** 页面限制，路由拦截器 */
router.beforeEach((to, from, next) => {
    console.log("toPath", JSON.stringify(to.path))
    console.log("toQuery", JSON.stringify(to.query))

    if (to.path == '/') // 即将进入的路由 不需要权限
    {
        next(); // 允许进入这个路由
    }
    else // 即将进入的路由 需要权限
    {
        if (window.sessionStorage.getItem("user")) // 能获取到user
        {
            let u = JSON.parse(window.sessionStorage.getItem("user"))
            console.log("user---->", u.type)
            if (u.type!==4) {
                initMenu(router, store); // 登录成功，初始化菜单.....
            }
            next(); // 允许进入这个路由
        }
        else // 获取不到user
        {
            next('/?redirect='+to.path); // 进入path路径
        }
    }
})

new Vue({
    data() {
      return {
          $g_data_business_category: null,
          $g_data_dev_model: null,
          $g_data_user_product_rate: null,
          $g_data_mini_rate: null
      }
    },
    router,
    store,
    render: h => h(App)
}).$mount('#app') // 挂载到入口vue文件<div id="app">
